import dayjs from "dayjs";
import { Breadcrumb, ConfirmDeleteModal, MyModal } from "ui";
import { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import { DataGrid, GridColDef } from "@mui/x-data-grid";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import { useState } from "react";
import { shortUserName } from "utils/helpers/shortUserName";
import { ActivityObject, demoActivities } from "assets/data/activity_data";
import { TextField } from "@mui/material";

const Activities = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        }
    ];

    const [activityData, setActivityData] = useState(demoActivities);
    const [deleteID, setDeleteID] = useState<string | number>("");
    const [openSingleModal, setOpenSingleModal] = useState(false);
    const [openAllModal, setOpenAllModal] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [viewActivity, setViewActivity] = useState<ActivityObject>();

    const handleDelete = (id: string | number) => {
        setDeleteID(id);
        setOpenSingleModal(true);
        // dispatch(removeActivity(id));
    };
    const removeActivity = (id: string | number) => {
        setActivityData(activityData.filter((i) => i.id !== id));
    };

    const handleDeleteAll = () => {
        setOpenAllModal(true);
    };
    const removeAllActivity = () => {
        setActivityData([]);
    };

    const handleView = (id: string | number) => {
        const activity = activityData.filter((n) => n.id === id)[0];
        if (activity) {
            setViewActivity(activity);
            setOpenView(true);
        }
    };

    const columns: GridColDef[] = [
        {
            field: "title",
            headerName: "Title",
            flex: 1,
            minWidth: 100,
            renderCell: (params) => (
                <span>{shortUserName(params.value, 20)}</span>
            )
        },
        {
            field: "msg",
            headerName: "Message",
            flex: 5,
            minWidth: 200,
            renderCell: (params) => (
                <span>{shortUserName(params.value, 30)}</span>
            )
        },
        {
            field: "createDate",
            headerName: "Create Date",
            renderCell: (params) => (
                <span>{dayjs(params.value).format("YYYY-MM-DD")}</span>
            ),
            flex: 2,
            minWidth: 100
        },
        {
            field: "id",
            headerName: "Actions",
            renderCell: (params) => (
                <div className="flex justify-center items-center gap-3 w-full">
                    <div
                        className="w-fit cursor-pointer"
                        onClick={() => handleView(params.value)}
                    >
                        <VisibilityRoundedIcon
                            className="dark:text-white"
                            fontSize="small"
                        />
                    </div>
                    <div
                        onClick={() => handleDelete(params.value)}
                        className="w-fit cursor-pointer"
                    >
                        <DeleteForeverIcon
                            className="dark:text-white"
                            fontSize="small"
                        />
                    </div>
                </div>
            ),
            flex: 3,
            minWidth: 170,
            align: "center",
            headerAlign: "center"
        }
    ];

    return (
        <>
            <section className="w-full h-full flex flex-col relative">
                <div className="w-full h-full flex relative  overflow-auto">
                    <div className="w-full flex flex-col">
                        <div className="w-full text-center">
                            <Breadcrumb
                                breadcrumb={breadcrumb}
                                currentPath="Activity"
                            />
                            <h1 className="font-medium text-lg dark:text-white py-4">
                                Admin Activity
                            </h1>
                        </div>
                        <div className="w-full items-center flex flex-col gap-3 px-10 ">
                            <div className="flex justify-end items-center gap-3  w-full">
                                <button
                                    className="bg-red-600 text-white text-center rounded-full w-fit px-3 py-1"
                                    onClick={() => handleDeleteAll()}
                                >
                                    Delete All
                                </button>
                            </div>
                            <div
                                className="table-data-grid"
                                style={{ height: 600, width: "100%" }}
                            >
                                <DataGrid
                                    rows={activityData}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                page: 0,
                                                pageSize: 15
                                            }
                                        }
                                    }}
                                    pageSizeOptions={[15, 30, 50, 100]}
                                    getRowId={(row: ActivityObject) => row.id}
                                    getRowClassName={(params) =>
                                        params.indexRelativeToCurrentPage %
                                            2 ===
                                        0
                                            ? "even"
                                            : "odd"
                                    }
                                    // checkboxSelection
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ConfirmDeleteModal
                text="Delete Notification"
                open={openSingleModal}
                setOpen={setOpenSingleModal}
                handleDelete={() => removeActivity(deleteID)}
            />
            <ConfirmDeleteModal
                text="Delete All Notifications"
                open={openAllModal}
                setOpen={setOpenAllModal}
                handleDelete={() => removeAllActivity()}
            />
            <MyModal open={openView} setOpen={setOpenView}>
                <div className="flex flex-col justify-center items-center gap-5">
                    <h1 className="dark:text-white font-bold ">
                        View Admin Activity
                    </h1>
                    {viewActivity && (
                        <div className="flex flex-col justify-center items-center gap-4 px-3 py-2 w-full">
                            <TextField
                                name="title"
                                label="Title"
                                value={viewActivity.title}
                                variant="outlined"
                                className="w-full"
                                disabled
                            />
                            {/* message */}
                            <TextField
                                name="msg"
                                label="Message"
                                placeholder="Your message..."
                                multiline
                                rows={6}
                                value={viewActivity.msg}
                                variant="outlined"
                                className="w-full"
                                disabled
                            />
                        </div>
                    )}
                </div>
            </MyModal>
        </>
    );
};

export default Activities;
